export default __webpack_public_path__ + "static/media/product.35d461a5.svg";